import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL } from "../Helpers";
import { STR_BUY_NOW, STR_PURCHASE_SUBSCRIPTION_PACKAGE, STR_SUBSCRIPTION_HAS_EXPIRED } from "../Strings";
import { MdCall, MdMessage, MdWarning, MdWhatsapp } from "react-icons/md";

export default function View({ data }) {
	const appContext = useContext(AppContext);

	/* Place states here */


	function view() {
		appContext.navTo({
			item: "integrated-apps",
			subItem: "mauzocrm",
			extraItem: "business",
			moreItem: data.uid
		});
	}

	return (
		<div
			className="card"
			onClick={view}
		>
			<div className="card-body">
				<h6
					style={{
						fontSize: "22px",
					}}
					className="font-semi-bold text-secondary mb-4"
				>
					{data.name}
				</h6>

				<h6
					style={{
						fontSize: "14px",
					}}
					className="font-semi-bold text-muted"
				>
					{data.uid}
				</h6>
				
			</div>
		</div>
	);
}
